export const lang = "en";



// WEBPACK FOOTER //
// ./src/translations/lang.js